import { BasicUseDocument, UseQuery, UseQueryCount } from '../types'

export const emptyUseQuery: UseQuery<any> = {
  data: null,
  dataArr: null,
  loading: false,
  error: null,
}

export const emptyUseQueryCount: UseQueryCount = {
  count: null,
  loading: false,
  error: null,
}

export const emptyBasicUseDocument: BasicUseDocument<any> = {
  data: null,
  loading: false,
  error: null,
  set: async () => {},
  update: async () => {},
}
